/**
 * Ссылка на форму создания аккаунтного API-токена Cloudflare с уже
 * выбранными правами. Клиенту остаётся нажать «Create Token» и скопировать
 * результат — вместо шести шагов по инструкции.
 *
 * Ключи прав подобраны и проверены на живой форме (dash.cloudflare.com,
 * сентябрь 2026): неизвестные ключи форма молча игнорирует, поэтому набор
 * держим точным. Аккаунтные права — на весь аккаунт, зонные — на все зоны:
 * зона клиента на момент выдачи токена ещё не известна.
 */
const ACCOUNT_PERMISSIONS = [
  { key: "stream", type: "edit" }, // видео, live inputs, keys, webhook
  { key: "stream_metadata", type: "read" },
  { key: "account_analytics", type: "read" }, // usage-плитка, просмотры
  { key: "notifications", type: "edit" }, // alerting-вебхуки live-статусов
  // Счета и entitlements аккаунта: показать клиенту расход Stream у нас в
  // кабинете. Read, а не edit: менять подписки клиента мы не должны.
  { key: "billing", type: "read" },
] as const;

const ZONE_PERMISSIONS = [
  { key: "zone", type: "read" }, // найти зону домена
  { key: "dns", type: "edit" }, // записи для витрины
  { key: "zone_settings", type: "edit" }, // SSL mode, Always HTTPS
  { key: "ssl_and_certificates", type: "edit" },
  { key: "cache_settings", type: "edit" }, // наши кеш-правила
  // Geo Vary опирается на заголовок x-viewer-country, который ставит
  // transform-правило из ip.src.country — без него кеш-правило бесполезно
  { key: "zone_transform_rules", type: "edit" },
] as const;

export const CLOUDFLARE_TOKEN_PERMISSION_KEYS = [
  ...ACCOUNT_PERMISSIONS,
  ...ZONE_PERMISSIONS,
];

export function buildCloudflareTokenUrl(tokenName: string): string {
  const params = new URLSearchParams({
    to: "/:account/api-tokens",
    permissionGroupKeys: JSON.stringify(CLOUDFLARE_TOKEN_PERMISSION_KEYS),
    name: tokenName,
  });

  return `https://dash.cloudflare.com/?${params.toString()}`;
}
